import RequiredValidator from "@/validators/RequiredValidator";

export default class AttachmentRules {

	public static readonly fileRules = [
		(new RequiredValidator('ui.terms.selectFile')).validationRule(),
	];

}
